import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import dateformat from 'dateformat';

import { fetchFrequentlySharedAssets, fetchRecommendedAssets } from 'actions/assets';
import FileService from 'services/file.service';
import defaultAsset from 'images/default_asset.jpg';
import GenerateLink from "components/generateLink";
import LockIcon from "components/lockIcon";
import AttachAsset from "components/attachAsset";
import { deselectAsset, selectAsset } from 'actions/selection';

import styles from "./recommendedAssets.module.scss";
import _ from "lodash";
import cx from 'classnames';

export default function RecommendedAssets(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const webAppUrl = process.env.REACT_APP_WEBAPP_URL;


  const recommendedAssets = useSelector((state) => _.get(state, 'assets.recommendedAssets.items') || []);
  const recommendedAssetsLoading = useSelector((state) => _.get(state, 'assets.recommendedAssets.loading')) || false;
  const assets = useSelector((state) => _.get(state, `application.assets`) || []);

  const [generateLink, setGenerateLink] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState();
  const [selectedAssetsCount, setSelectedAssetsCount] = useState(0);
  const [selectedAssets, setSelectedAssets] = useState([]);

  useEffect(() => {
    dispatch(fetchRecommendedAssets());
  }, []);

  useEffect(() => {
    setSelectedAssets(assets);
  }, [assets])

  const renderAssetSummary = (asset) => { 
    const pages = _.get(asset, "metadata.pages", 0);
    const video_duration = _.get(asset, "metadata.video_duration", 0);

    if (_.size(pages) > 0) {
      return (
        <div className={styles.metrics}>
          <span>{pages} Pages</span>
        </div>
      );
    } else if (_.size(video_duration) > 0) {
      return (
        <div className={styles.metrics}>
          <span>{formartVideoDuration(video_duration)}</span>
        </div>
      );
    }

    return false;
  }

  const formartVideoDuration = (timeSpent) => {
    let timeSpentValue = `${padNumber(timeSpent, 1)} Seconds`;

    if (timeSpent >= 60) {
      var minutes = Math.round(timeSpent / 60);
      timeSpentValue = `${padNumber(minutes, 1)} Minute${minutes == 1 ? '' : 's'}`;
    }

    return timeSpentValue;
  }

  const padNumber = (number = 0, pad) => {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }

  const handleSelectAsset = (selectedAsset) => {  
    if(assets.map(item => item.id).includes(selectedAsset.id)){
      dispatch(deselectAsset(selectedAsset));
      const filteredAssets = selectedAssets.filter(asset => asset.id != selectedAsset.id);
      setSelectedAssets(filteredAssets);
    }else{
      let asset = {...selectedAsset, entityType: 'asset'};
      setSelectedAssets([...selectedAssets, asset]);
      const allAssets = [...selectedAssets, asset];
      allAssets.map(asset => dispatch(selectAsset(asset)));
    }
  }

  const isSelected = (asset) => {
    return assets.map(item => item.id).includes(asset.id);
  }

  const handleAttachAssets = () => {
    history.push("/attachAssets");
  }

  return (
    <>
      <div className={cx(styles.recommendedAssets, { [styles.recommendedAssetsPage]: !props.carousel })}>
        {!props.carousel &&
          <p className={styles.headerContainer}>
          <span className={styles.backButton} onClick={() => history.push('/paperflite-home')}>
          <i className="paperflite-left-arrow"/>
            <span className={styles.back}>
              BACK
            </span>
            </span>
          </p>
        }

        {selectedAsset && <GenerateLink entity={selectedAsset} type="asset" show={generateLink} setShow={setGenerateLink} />}

        <p className={styles.recommendedAssetsTitle}>Recommended Assets </p>
        <div className={cx(styles.assets, {
          [styles.adjustedAssets] : !props.carousel
        }
          )}>
          {!recommendedAssetsLoading && recommendedAssets.map((asset, i) => {
            var assetSummary = renderAssetSummary(asset);
            return (
              <div key={asset.id} className={cx(styles.asset)}>
                <span className={cx(styles.assetIcon)}>
                  {asset.settings && !asset.settings.share && <LockIcon />}
                  <img
                    alt="asset thumbnail"
                    src={_.get(asset, "icon.thumbnail") || defaultAsset} 
                    className={cx({
                      [styles.selectedAssetIcon] : isSelected(asset)
                    })}
                    onClick={() => handleSelectAsset(asset)}
                    />
                  {!_.isEmpty(FileService.fileType(asset.metadata)) &&
                    <p className={styles.fileType}>{FileService.fileType(asset.metadata)}</p>
                  }
                </span>
             
                  <div className={styles.recommendedAssetsText}>
                    <p className={styles.recommendedAssetsHeading}>{asset.name}</p>
                    <p className={styles.recommendedAssetsSubHeading}>
                      {assetSummary &&
                        <span className={styles.assetSummary}>{assetSummary}</span>
                      }
                      <span>{FileService.formatSize(_.get(asset, "metadata.content_length", 0))}</span>
                    </p>
                    {asset.modifiedDate != null && 
                      <p className={styles.recommendedAssetsSubText}>Last update {dateformat(asset.modifiedDate, 'dd mmm yyyy')}</p>
                    }
                     <a href = {`${webAppUrl}/assets/${asset.id}`} target = "_blank" className={styles.previewAsset}>
                      <i className={cx(styles.previewIcon , "paperflite-left-arrow")}></i>
                      <span className={styles.previewText}>OPEN</span>
                      </a>
                  </div>
              
              </div>
            )
          })}
          {!recommendedAssetsLoading && _.size(recommendedAssets) == 0 && 
          <div className="">
            <span>No recommended assets</span>
          </div>}
          {recommendedAssetsLoading && _.times(5).map((i) => {
            return (
              <div key={i} className={styles.asset}>
                <span className={styles.assetIcon}>
                  <img
                    alt="asset thumbnail"
                    src={defaultAsset} />
                </span>
                  <div className={styles.recommendedAssetsText}>
                    <p className={cx(styles.recommendedAssetsLoading, styles.recommendedAssetsHeading)}>Asset Name</p>
                    <p className={cx(styles.recommendedAssetsSubText, styles.recommendedAssetsLoading, styles.recommendedAssetsSubTextLoading)}>Last updated</p>
                  </div>
              </div>)
          })
          }
        </div>

        {_.size(assets) > 0 &&
          <div className={cx(styles.selectedAssetsContainer, {
            [styles.selectedAssetsContainerCarousel] : props.carousel
          })} 
          onClick = {() => handleAttachAssets()}
          >
            <span className={styles.selectedAssets}>SELECTED ASSETS ({_.size(assets)})</span>
          </div>
      }
      </div>
    </>
  )
}